import React, { useState, useRef } from "react";
import { Formik, Field, Form, ErrorMessage } from "formik";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import { Box, Button, Grid, TextField } from "@mui/material";
import { editChecklist } from "../../services";
import Images from "../../assets";
import { useAppDispatch } from "../../assets/hooks";
import { closePopup } from "../../store/slices/popupSlice";


interface FormValues {
  name: string;
  desc: string;
  applicationId: string;
  checklistItemId: string;
  isChecked: boolean;
  action: string;
  uploaded_file: string,

}

const EditChecklist = (props:any) => {
  const [file, setFile] = useState<File | null>(null);
  const [loading, setLoading] = useState(false);
  const inputFile = useRef<HTMLInputElement | null>(null);
  const dispatch = useAppDispatch();
  const imageClick = () => {
    if (inputFile.current) {
      inputFile.current.click();
    }
  };

  const initialValues: FormValues = {
    name: props.data.editData?.name,
    desc: props.data.editData?.desc || "",
    applicationId: props.data?.id,
    checklistItemId: props.data?.editData?._id,
    isChecked: props.data.editData?.isChecked,
    uploaded_file: props.data.editData?.doc?props.data.editData?.doc?.name :file,
    action: "edit",
  };

  const submit = async (values: FormValues) => {
    setLoading(true);
    console.log(values)
    if (values) {
      const response = await editChecklist(values);
      if (response) {
        props.data.setChecklist(response?.data?.data?.docChecklist);
      } else {
      }
    }
    setLoading(false);
    dispatch(closePopup())
  };

  return (
    <div>
      <Formik
        initialValues={initialValues}
        onSubmit={(values) => submit(values)}
      >
        {({ values ,handleChange}) => (
          <Form>
            <div>
              <div className="mb-5">
                <Grid container spacing={2}>
                  <Grid
                    item
                    xs={12}
                    sx={{ display: "flex", flexDirection: "column" }}
                  >
                    <label htmlFor="name" style={{ marginBottom: "0.3rem", fontWeight: "500"  }}>
                      Name
                    </label>
                    <TextField
                      name="name"
                      style={{ height: "2.5rem" }}
                      placeholder="Checklist name"
                      type="text"
                      required
                      size="small"
                      value={values.name}
                      onChange={handleChange}
                    />
                    <ErrorMessage
                      name="name"
                      component="div"
                      className="field-error"
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sx={{ display: "flex", flexDirection: "column" }}
                  >
                    <label htmlFor="desc" style={{ marginBottom: "0.3rem", fontWeight: "500"  }}>
                      Description
                    </label>
                    <TextField
                      required
                      name="desc"
                      placeholder="Add description"
                      type="text"
                      multiline
                      size="small"
                      onChange={handleChange}
                      value={values.desc}
                    />
                    <ErrorMessage
                      name="desc"
                      component="div"
                      className="field-error"
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sx={{ display: "flex", alignItems: "center" }}
                  >
                    <Field name="isChecked" type="checkbox" style={{width:"1rem",height:"1rem"}}/>
                    <label
                      htmlFor="isChecked"
                      style={{ marginBottom: "0.3rem", marginLeft: "0.8rem", fontWeight: "500"  }}
                    >
                      Checked
                    </label>
                    <ErrorMessage
                      name="isChecked"
                      component="div"
                      className="field-error"
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sx={{ display: "flex", flexDirection: "column" }}
                  >
                    <div className="flex" style={{display:"flex"}}>
                      <label
                        htmlFor="uploaded_file"
                        style={{
                          marginBottom: "0.3rem",
                          marginRight: "0.8rem"
                          , fontWeight: "500" 
                        }}
                      >
                        Upload file
                      </label>
                      <input
                        style={{ display: "none" }}
                        type="file"
                        accept=".pdf"
                        name="uploaded_file"
                        onChange={(e) =>
                          setFile(e.target.files ? e.target.files[0] : null)
                        }
                        ref={inputFile}
                      />
                      <FileUploadOutlinedIcon
                        onClick={imageClick}
                        sx={ { color: "#000" }}
                      />
                      <h4 style={{ marginTop: "5px" }}>
                        {file ? file.name : props.data.editData?.doc?.name}
                      </h4>
                    </div>
                  </Grid>
                </Grid>
              </div>
            </div>
            <Box sx={{ textAlign: "center" }}>
            <Button
                type="submit"
                sx={{
                  color: "#fff",
                  background: "#3B3F76",
                  borderRadius: "5px",
                  textTransform: "none",
                  fontSize: "0.8rem",
                  "&:hover": {
                    background: "#3B3F76",
                  },
                }}
              >
                {loading ? (
                  <Box
                    component="img"
                    src={Images.standardLoader}
                    alt="standardLoader"
                    sx={{ width: "1rem", height: "1rem" }}
                  />
                ) : (
                  "Save"
                )}
              </Button>
            </Box>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default EditChecklist;
